import React, { Component } from 'react';

import HeaderNav from './HeaderNav/HeaderNav';

import './Header.css';

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <header className="Header">
        <HeaderNav />
      </header>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/Header.js